import { UserType, UserRole } from '../types/plan';

/**
 * Classe para validação de acesso a planos (Single Responsibility)
 */
export class PlanAccessValidator {
  // Verifica se o usuário é paciente
  static isPatient(userRole: string): boolean {
    return userRole === UserRole.PARTICIPANT || userRole === UserRole.LOGIN_NOT_COMPLETED;
  }

  // Verifica se o usuário é terapeuta
  static isTherapist(userRole: string): boolean {
    return userRole === UserRole.THERAPIST;
  }

  // Verifica se o usuário é admin
  static isAdmin(userRole: string): boolean {
    return userRole === UserRole.ADMIN;
  }

  // Valida se o usuário pode acessar um plano
  static canAccessPlan(userRole: string, planUserType: UserType): { 
    canAccess: boolean; 
    title?: string;
    message?: string; 
    redirectTo?: string;
    variant?: 'error' | 'warning' | 'info';
  } {
    const isPatient = this.isPatient(userRole);
    const isAdmin = this.isAdmin(userRole);

    // Admin pode acessar tudo
    if (isAdmin) {
      return { canAccess: true };
    }

    // Paciente tentando acessar plano de terapeuta
    if (isPatient && planUserType === UserType.THERAPIST) {
      return {
        canAccess: false,
        title: 'Plano Exclusivo para Terapeutas',
        message: 'Este plano é exclusivo para profissionais terapeutas. Por favor, escolha um plano para participantes na seção correspondente.',
        redirectTo: '/planos',
        variant: 'warning'
      };
    }

    return { canAccess: true };
  }
}
